import { render } from "./PhishingView.vue?vue&type=template&id=f027c09e&scoped=true"
import script from "./PhishingView.vue?vue&type=script&lang=js"
export * from "./PhishingView.vue?vue&type=script&lang=js"

import "./PhishingView.vue?vue&type=style&index=0&id=f027c09e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f027c09e"]])

export default __exports__